import { LoaderCircle } from 'lucide-react'
import { ReactNode } from 'react'

type LoadingPageProps = {
  children?: ReactNode
}

const LoadingPage = ({ children }: LoadingPageProps) => {
  return (
    <div className="h-dvh flex flex-col items-center justify-center">
      <div className="flex-grow flex flex-col gap-4 justify-center items-center">
        <LoaderCircle className="animate-spin h-16 w-16 text-primary" />
        {children || <span className="text-muted-foreground font-medium mb-2">Loading...</span>}
      </div>
    </div>
  )
}

export { LoadingPage }
